<template>
    <div class="header-panel" :class="[rootClasses]">
        <transition name="trs-header-panel-switch">
            <div v-if="!isLocation" key="main" class="header-panel--main" :style="scrollLockStyles">
                <div class="header-panel--brand">
                    <transition name="trs-simple-fade">
                        <a v-if="isContent || isHomeIntroDismissed" class="u-reset header-panel--home-link"
                                :href="partial.content.home_link.to" @click.prevent="onHomeLinkRequested()">
                            <img class="header-panel--logo" :src="'img/im_vehi-logo.svg' | static" alt="">
                        </a>
                    </transition>
                </div>
                <div class="header-panel--nav">
                    <cmp-main-nav v-if="!isMobile" facet="base" :has-rail="true"></cmp-main-nav>
                    <cmp-mobile-nav-toggle v-else></cmp-mobile-nav-toggle>
                </div>

                <div v-if="!isMobile" class="header-panel--rail"></div>
            </div>

            <div v-else key="detail" class="header-panel--detail">
                <router-link class="btn btn__large btn__bubble btn__light header-panel--back-link"
                        v-bind="partial.content.home_link">
                    <cmp-icon symbol="chevron-left" size="small"></cmp-icon>
                </router-link>
            </div>
        </transition>

        <transition name="trs-mobile-nav-toggle"
                @enter="onScrollLockEnterHook"
                @afterLeave="onScrollLockAfterLeaveHook">
            <cmp-main-nav v-if="isMobile && navigation.mobile.isOpen"
                    class="header-panel--mobile-nav"
                    facet="mobile">
            </cmp-main-nav>
        </transition>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import bemMixin from 'framework/mixins/bem';
    import isMobileMixin from 'framework/mixins/is-mobile';
    import scrollLockHelperMixin from 'framework/mixins/scroll-lock-helper';
    import cmsPartialMixin from 'framework/mixins/cms/cms-partial';


    export default {
        mixins: [
            bemMixin('header-panel'),
            isMobileMixin,
            scrollLockHelperMixin,
            cmsPartialMixin,
        ],
        props: {
            partialName: {
                type: String,
                default: 'menu',
            },
        },
        computed: {
            ...mapGetters(['navigation', 'pageType', 'isHomeIntroDismissed']),
            rootClasses() {
                return [
                    this.bemAdd(this.pageType),
                ];
            },
            isLocation() {
                return this.pageType === 'page-location';
            },
            isContent() {
                return this.pageType === 'page-content';
            },
        },
        methods: {
            ...mapActions(['dismissHomeIntro', 'setMobileNavigation']),
            onHomeLinkRequested() {
                this.$router.push(this.partial.content.home_link.to);
                this.dismissHomeIntro({ isHomeIntroDismissed: false });
                this.setMobileNavigation({ isOpen: false });
            },
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/header-panel/index.vue?49505849